import React from 'react';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import Images from '../../components/images';
import * as WSC from "../../WSHelper/WSConstants";
import * as AppLabels from "../../helper/AppLabels";
import { MyContext } from '../../InitialSetup/MyProvider';
import { Helmet } from "react-helmet";
import MetaData from "../../helper/MetaData";
import { ApplyPromoCode } from "../../Modals";
import { Utilities, _Map } from '../../Utilities/Utilities';
import CustomHeader from '../../components/CustomHeader';
import { depositJustPayFund, getDealsAPI } from '../../WSHelper/WSCallings';
import * as Constants from "../../helper/Constants";

export default class AddFunds extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            otherDeals: [],
            allDeals: [],
            bestDeal: '',
            selectedDeal: '',
            amount: '',
            isBeastDealSelected: false,
            showPromoCode: false,
            mPromoCodeObj: '',
            fromConfimPopUpFunds: this.props.location.fromConfirmPopupAddFunds,
            contestDataForFunds: this.props.location.contestDataForFunds,
            fromBuyCoin: this.props.location.state && this.props.location.state.fromBuyCoin ? this.props.location.state.fromBuyCoin : '',
            AddAmt: this.props.location.state && this.props.location.state.amountToAdd ? this.props.location.state.amountToAdd : this.props.location.contestDataForFunds ? this.props.location.contestDataForFunds.AmountToAdd :'',
            RFContestId: ''
        }
    }

    componentDidMount() {
        if(Constants.SELECTED_GAMET == Constants.GameType.DFS && Constants.RFContestId != ''){
            this.setState({
                RFContestId:Constants.RFContestId
            })
        }
        if (Utilities.getMasterData().a_deal == 1) {
            this.getDeals()
        }
        else{
            this.setState({
                amount: this.state.AddAmt || ''
            })
        }
    }

    getDeals() {
        let param = {}
        this.setState({ isLoaderShow: true })
        getDealsAPI(param).then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {
                this.setState({ allDeals: responseJson.data })
                this.getBestDeal(responseJson.data)
            }
        })
    }

    getBestDeal(deals) {
        let bestDealIndex = 0;
        let bestDeal = deals[bestDealIndex];
        if(bestDeal){
            let bestDealAdditionalAmt = (parseFloat(bestDeal.bonus) + parseFloat(bestDeal.cash)) / parseFloat(bestDeal.amount);
            for (let i = 0; i < deals.length; i++) {
                let tempAdditionalAmt = (parseFloat(deals[i].bonus) + parseFloat(deals[i].cash)) / parseFloat(deals[i].amount);
                if (tempAdditionalAmt >= bestDealAdditionalAmt) {
                    bestDealAdditionalAmt = tempAdditionalAmt;
                    bestDealIndex = i;
                    bestDeal = deals[bestDealIndex];
                }
            }
            let otherDeals = deals.filter(item => item != bestDeal);
            this.setState({ 
                bestDeal: bestDeal, 
                otherDeals: otherDeals, 
                selectedDeal: '',
                // amount: this.state.fromConfimPopUpFunds ? this.state.contestDataForFunds.AmountToAdd : '', 
                amount: this.state.fromConfimPopUpFunds ? this.state.contestDataForFunds.AmountToAdd : (this.state.fromBuyCoin ? this.state.AddAmt : ''), 
                isBeastDealSelected: false 
            })
        }
        else{
            this.setState({
                amount: this.state.fromConfimPopUpFunds ? this.state.contestDataForFunds.AmountToAdd : (this.state.fromBuyCoin ? this.state.AddAmt : ''),
            })
        }
    }

    handleChange = (e) => {
        let amt = e.target.value;
        let mAllDeals = this.state.allDeals;
        let isExist = mAllDeals.filter(item => item.amount == amt)

        if (isExist.length > 0) {
            this.setState({ amount: amt, selectedDeal: isExist[0], isBeastDealSelected: true, mPromoCodeObj: '' })
        }
        else {
            this.setState({ amount: amt, selectedDeal: '', isBeastDealSelected: false, mPromoCodeObj: '' })
        }
        if (amt == '') {
            this.setState({
                amount: '',
                selectedDeal: ''
            })
        }
    }

    goToPaymentOptions() { 
        let inputAmt = this.state.amount != '' ? this.state.amount : this.state.selectedDeal.amount;
        if (parseFloat(inputAmt || 0) >= Constants.minDep) {            
            const param =    {
                "amount": this.state.amount != '' ? this.state.amount : this.state.selectedDeal.amount,
                "deal_id": this.state.amount != '' ? this.state.selectedDeal.deal_id : "",
                "promo_code": "",
                "description":"Deposit",
                "pg_option" : "juspay"
            }
            depositJustPayFund(param).then((responseJson) => {
                if (responseJson.response_code == WSC.successCode) {
                    const successResp = responseJson.data.successResponse
                    if( successResp) {
                        const paymentLink = successResp.payment_links ? successResp.payment_links.web : null
                        if(paymentLink) {
                            window.location.href = paymentLink;
                         }
                    }

                }
            })
            return
            this.props.history.push({
                pathname: '/payment-method', state: {
                    amount: this.state.amount != '' ? this.state.amount : this.state.selectedDeal.amount,
                    selectedDeal: this.state.selectedDeal,
                    fromConfimPopUpFunds: this.state.fromConfimPopUpFunds,
                    promoCode:this.state.mPromoCodeObj?this.state.mPromoCodeObj.promo_code:'',
                    isReverseF : this.props && this.props.location.isReverseF || false
                }
            })
        }
        else {
            const text = AppLabels.ENTERED_AMOUNT_MUST_BE_5.replace('placeholder', Constants.minDep);
            Utilities.showToast(text, 2500);
        }
    }

    /**
   * @description method to display promo modal
   */
    PromoCodeShow = () => {
        let inputAmt = this.state.amount != '' ? this.state.amount : this.state.selectedDeal.amount;
        if(!inputAmt) return;
        if ((inputAmt.toString() || '').trim() != '' && parseFloat(inputAmt) >= Constants.minDep) {
            this.setState({
                showPromoCode: true,
            });
        }
        else {

            const text = AppLabels.ENTERED_AMOUNT_MUST_BE_5.replace('placeholder', Constants.minDep);
            Utilities.showToast(text, 2500);
        }
    }
    /**
     * @description method to hide promo modal
     */
    PromoCodeHide = () => {
        this.setState({
            showPromoCode: false,
        });
    }
    /**
     * @description method to apply promo 
     */
    onApplyPromoCode = (obj) => {
        this.setState({
            mPromoCodeObj: obj,
            showPromoCode: false,
        });
    }



    render() {
        const HeaderOption = {
            back: true,
            notification: false,
            title: AppLabels.ADD_FUNDS,
            fromAddFund: false,
            hideShadow: true,
            showBal: Constants.OnlyCoinsFlow == 0
        }
        const { selectedDeal, bestDeal, isBeastDealSelected, amount, showPromoCode, mPromoCodeObj } = this.state;
        return (
            <MyContext.Consumer>
                {(context) => (
                    <div className="web-container web-container-fixed add-funds-wrapper white-bg">
                        <Helmet titleTemplate={`${MetaData.template} | %s`}>
                            <title>{MetaData.addfunds.title}</title>
                            <meta name="description" content={MetaData.addfunds.description} />
                            <meta name="keywords" content={MetaData.addfunds.keywords}></meta>
                        </Helmet>
                        <CustomHeader {...this.props} HeaderOption={HeaderOption} />
                        <div className="add-funds-header">
                            <div>
                                <FormGroup
                                    className={"position-relative show-currency-icn" + (this.state.amount == '' ? ' chnage-icon-color' : '')}
                                    controlId="formBasicText"
                                >
                                    <ControlLabel>{AppLabels.ENTER_AMOUNT} ({Utilities.getMasterData().currency_code})</ControlLabel>
                                    <FormControl
                                        autoComplete='off'
                                        value={this.state.amount}
                                        type={'number'}
                                        placeholder={'0'}
                                        onChange={this.handleChange}
                                        disabled = {this.state.fromBuyCoin}
                                        readOnly = {this.state.fromBuyCoin}
                                    />
                                        <span className="forminput-currency">
                                            {Utilities.getMasterData().currency_code}
                                        </span>
                                </FormGroup>
                            </div>
                        </div>
                        <div className="add-funds-body">
                            {Utilities.getMasterData().a_deal == 1 &&
                                <React.Fragment>
                                    <div className="amount-section">
                                        {_Map(this.state.otherDeals, (item, idx) => {
                                            return (<a key={idx} onClick={() => this.setState({ selectedDeal: item, amount: item.amount, isBeastDealSelected: true })} className={(item.deal_id == selectedDeal.deal_id ? ' selected' : '')} href id="amt-2">{Utilities.getMasterData().currency_code} {item.amount} {item.deal_id == selectedDeal.deal_id && <i className="icon-tick-ic"></i>}</a>)
                                        })}
                                    </div>
                                    {bestDeal && <div onClick={() => this.setState({ selectedDeal: bestDeal,amount: bestDeal.amount,isBeastDealSelected: true })} className={"best-deal " + (bestDeal.deal_id == selectedDeal.deal_id ? ' selected' : '')}>
                                        <img src={Images.FAVOURITE} alt="" />
                                        {AppLabels.PICK_BEST_DEAL}
                                        <span>{Utilities.getMasterData().currency_code} {bestDeal.amount}</span>
                                        <i className="icon-tick-ic"></i>
                                    </div>}
                                    {
                                      isBeastDealSelected &&  <div className="selected-deal-offer">
                                        <div className="deposite-heading">{AppLabels.DEPOSIT} <span>{Utilities.getMasterData().currency_code} {this.state.amount != '' ? this.state.amount : this.state.selectedDeal.amount}</span></div>
                                        <div className="additional-benifit-section">
                                            <div className="heading">{AppLabels.YOU_WILL_ADDITIONALLY_GET}</div>
                                            <div className="bonus-offer">
                                            {selectedDeal.bonus > 0 && <>
                                                <div>
                                                    <div className="bonus-amt"><i className="icon-bonus"></i>{selectedDeal.bonus ? selectedDeal.bonus : 0}</div>
                                                    <div className="bonus-label">{AppLabels.BONUS_CASH}</div>
                                                </div>
                                                <div>
                                                    <i className="icon-plus-ic"></i>
                                                </div>
                                                </>}
                                                <div>
                                                    <div className="bonus-amt">{Utilities.getMasterData().currency_code}{selectedDeal.cash ? selectedDeal.cash : 0}</div>
                                                    <div className="bonus-label">{AppLabels.REAL_CASH}</div>
                                                </div>
                                                {Utilities.getMasterData().a_coin == 1 && selectedDeal.coin > 0 && <>
                                                <div>
                                                    <i className="icon-plus-ic"></i>
                                                </div>
                                                <div>
                                                    <div className="bonus-amt"><img className="coin-img" src={Images.IC_COIN} alt="" />{selectedDeal.coin ? selectedDeal.coin : 0}</div>
                                                    <div className="bonus-label">{AppLabels.COINS}</div>
                                                </div>
                                                </>}
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </React.Fragment>
                            }
                            {(!isBeastDealSelected || Utilities.getMasterData().a_deal == 0) &&
                                <React.Fragment>
                                    {mPromoCodeObj == '' ?
                                        <div onClick={() => this.PromoCodeShow()} className="promo-code-section">{AppLabels.HAVE_A_PROMO_CODE}</div>
                                        :
                                        <div className="promo-code-section">
                                            <span>{AppLabels.PROMO_CODE}{' '}{AppLabels.OF}{' '}</span>
                                            {mPromoCodeObj.cash_type == '1' ? Utilities.getMasterData().currency_code : <span><i className='icon-bonus' /></span>}
                                            {mPromoCodeObj.discount}
                                            {' '}
                                            <span> {AppLabels.PROMO_TEXT3}
                                                {'  '}   <a href onClick={() => this.setState({ mPromoCodeObj: "" })}><i className='icon-cross-circular' /></a>
                                            </span>
                                        </div>
                                    }
                                </React.Fragment>
                            }
                            <div className="text-center btm-fixed-action add-fund">
                                <a href onClick={() => (amount != '' || selectedDeal != '') && this.goToPaymentOptions()} className="button button-primary-rounded button-block">{AppLabels.ADD_CASH}</a>
                                {Constants.OnlyCoinsFlow == 0 && <div className="card-img-section">
                                <img src={Images.CARD_IMG} alt=""/>
                            </div>}
                            </div>
                            {
                                showPromoCode &&
                                <ApplyPromoCode
                                    IsPromoCodeShow={showPromoCode}
                                    IsPromoCodeHide={this.PromoCodeHide}
                                    onApplyPromoCode={this.onApplyPromoCode}
                                    mAmount={amount}
                                />
                            }

                        </div>
                    </div>
                )}
            </MyContext.Consumer>
        )
    }
}